import React from 'react';
import { HERO } from '../data';
import './Hero.css';

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero__bg" />
      <div className="hero__inner container">
        <div className="hero__content">
          {HERO.eyebrow ? <span className="hero__eyebrow">{HERO.eyebrow}</span> : null}
          <h1 className="hero__title">{HERO.title}</h1>
          <p className="hero__subtitle">{HERO.subtitle}</p>
          <div className="hero__actions">
            <button
              className="btn-primary"
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
            >
              View Services
            </button>
            <button
              className="btn-outline hero__btn-outline"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Let's Talk
            </button>
          </div>
        </div>

        <div className="hero__photo-wrap">
          {HERO.photoPlaceholder ? (
            <div className="hero__photo-placeholder">
              <span>Your Photo</span>
            </div>
          ) : (
            <img
              src={HERO.photo}
              alt="XBC Solutions"
              className="hero__photo"
            />
          )}
        </div>
      </div>
    </section>
  );
}
